import React from "react";


function VideoStreamRenderer({url, fileMeta}) {
    return (
        <video width="500" height="500" controls>
            <source src={url} type={fileMeta.contentType} />
            Your browser does not support video.
        </video>
    )
}

export default VideoStreamRenderer;
